import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import { responseHandler, sendData, socket } from '../../../store/actions'
import Layout from '../../../components/layout/Layout'
import {checkLowercase, checkMinLength, checkNumeric, checkSpecialCharacter, checkUppercase, isMobileDevice} from 'ubs-framework/v2/common/function'
import { COLOR, REGEX } from '../../../common/constant'
import AppHeader from '../../common/components/app-header'
import UInput from "ubs-framework/v2/UInput"
import * as Icon from 'ubs-icons'
import Validator from 'simple-react-validator'
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import UPopup from "ubs-framework/v2/UPopup";
import Commonrightcircle from '../../../common/component/RightCircle/commonrightcircle'
import useSocket from '../../common/useSocket'
import {withRouter} from "../../../common/hocs/routing-hoc";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

function OnBoardingRegister(props) {
    const dispatch = useDispatch()
    const history = useHistory()
    const {orgId} = useParams()

    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate },
        validators: {
            uppercase: {  // name the rule
                message: 'Please use uppercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.upperCase) && params.indexOf(val) === -1
                },
            },
            lowercase: {  // name the rule
                message: 'Please use lowercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.lowerCase) && params.indexOf(val) === -1
                },
            },
            specialcase: {  // name the rule
                message: 'Please use one special character.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.specialChar) && params.indexOf(val) === -1
                },
            },
            number: {  // name the rule
                message: 'Please use one number.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.number) && params.indexOf(val) === -1
                },
            },
        },
    }))

    const [errorMsg, setErrorMsg] = useState('')
    const [disabledBtn, setDisabledBtn] = useState(false)
    const [passwordEye, setPasswordEye] = useState(false)
    const [hide, setHide] = useState(false)
    const [registerDetail, setRegisterDetail] = useState({
        email: '',
        password: '',
        cpassword: ''
    })

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                default:
                    return true
            }
        }
    })

    useEffect(() => {
        refresh()
        return () => off()
    }, [])
    useEffect(() => {
        socket.on('response', (response) => {
            let res = responseHandler(response)
            if (!res.error) {
                setDisabledBtn(false)
                switch (res.event) {
                    case 'onboardingSignUp': {
                        setDisabledBtn(true)
                        history.push(props?.projectRoutes?.login || `/${orgId}/login`)
                        break;
                    }
                    default:
                        return true
                }
            } else {
                setErrorMsg(res.data.error)
                setTimeout(() => setErrorMsg(res.data.error), 5000)
            }
        })
    }, [])


    const inputEvent = (e) => {
        let { name, value } = e.target
        value = value.replace(/^\s+/g, '').trim()
        setRegisterDetail((val) => {
            return { ...val, [name]: value }
        })
    }

    const onKeyUp = (e) => {
        if (e.key === "Enter") {
            onSubmit(e);
        }
    }
    const onSubmit = () => {
        if (validator?.current?.allValid()) {
            if (registerDetail?.cpassword !== registerDetail?.password) {
                setErrorMsg('Password and confirm password does not match')
            } else {
                setDisabledBtn(true)
                const data = {
                    email: registerDetail.email,
                    password: registerDetail.password,
                    orgId,
                }
                sendData(dispatch, 'onboardingSignUp', data)
            }
        } else validator?.current?.showMessages()
    }

    return (
        <React.Fragment>
            <Layout module="on-boarding-register">
                <div className="u_account-form">
                    <Commonrightcircle/>
                    <AppHeader header="Sign Up Your Account" title="Please Sign Up to access Superworks"/>
                </div>

                <div className="u_account-form">
                    <UInput
                        hasError={validator?.current?.message('email', registerDetail?.email, 'required|email')}
                        className="u_mb-20"
                        label="Email Address"
                        asterisk
                        testId={TEST_ID.ONBOARDING_REGISTER.INPUT_WRAPPER}>
                        <input
                            name="email"
                            value={registerDetail?.email}
                            onChange={inputEvent}
                            placeholder=" "
                            data-testid={TEST_ID.ONBOARDING_REGISTER.EMAIL_INPUT} />
                    </UInput>

                    <UInput
                        className="u_mb-20"
                        label="New Password"
                        password
                        asterisk
                        hasError={validator?.current?.message('password', registerDetail?.password, 'required|min:8|uppercase|lowercase|specialcase|number')}
                        testId={TEST_ID.ONBOARDING_REGISTER.INPUT_WRAPPER}>
                        <input
                            onChange={inputEvent}
                            value={registerDetail?.password}
                            name="password"
                            onKeyUp={onKeyUp}
                            type={`${passwordEye ? 'text' : 'password'}`}
                            autoComplete="off"
                            placeholder=" "
                            data-testid={TEST_ID.ONBOARDING_REGISTER.PASSWORD_INPUT} />
                        <div className="u_input-note u_ib">
                            <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                    desc={<span>{!passwordEye ? 'Show Password' : 'Hide Password'} </span>}>
                                <span className="u_rollover u_cp u_flex"
                                      onClick={() => setPasswordEye(!passwordEye)} data-testid={TEST_ID.ONBOARDING_REGISTER.PASSWORD_TOGGLE} >{!passwordEye ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup></div>
                    </UInput>
                    <UInput
                        className="u_mb-20"
                        label="Confirm Password"
                        password
                        asterisk
                        hasError={validator?.current?.message('ConfirmPassword', registerDetail?.cpassword, 'required|min:8|uppercase|lowercase|specialcase|number')}
                        testId={TEST_ID.ONBOARDING_REGISTER.INPUT_WRAPPER}>
                        <input
                            onChange={inputEvent}
                            value={registerDetail?.cpassword}
                            name="cpassword"
                            onKeyUp={onKeyUp}
                            type={`${hide ? 'text' : 'password'}`}
                            autoComplete="off"
                            placeholder=" "
                            data-testid={TEST_ID.ONBOARDING_REGISTER.CONFIRM_PASSWORD_INPUT} />
                        <div className="u_input-note u_ib">
                            <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                    desc={<span>{!hide ? 'Show Password' : 'Hide Password'} </span>}>

                                <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)} data-testid={TEST_ID.ONBOARDING_REGISTER.PASSWORD_TOGGLE} >{!hide ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup>
                        </div>
                    </UInput>

                    {errorMsg.length !== 0 && (
                        <p className="u_error-message u_mb-15">{errorMsg}</p>
                    )}

                    <div className="u_reset-content u_mb-10">
                        <ul className="u_flex u_flex-wrap">
                            <li style={{color: `${checkMinLength(registerDetail.password, 8) ? '#60B158' : '#8F95A6'}`}}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                 fill={`${checkMinLength(registerDetail?.password, 8) ? '#60B158' : '#8F95A6'} `}/>Minimum
                                8 Characters
                            </li>
                            <li style={{color: `${checkUppercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                 fill={`${checkUppercase(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>Uppercase
                            </li>
                            <li style={{color: `${checkLowercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                 fill={`${checkLowercase(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>Lowercase
                            </li>
                            <li style={{color: `${checkNumeric(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                 fill={`${checkNumeric(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>1
                                Numeric Number
                            </li>
                            <li style={{color: `${checkSpecialCharacter(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                 fill={`${checkSpecialCharacter(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>1
                                Special Character
                            </li>
                        </ul>
                    </div>

                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmit}
                            className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.ONBOARDING_REGISTER.BUTTON}>Sign Up
                        </button>
                        {disabledBtn &&
                        <div className="u_btn-loader"><Icon.Preloader size={70}/></div>}
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
}

export default withRouter(OnBoardingRegister)
